import { render, staticRenderFns } from "./PagePlanogram.vue?vue&type=template&id=47ccd1ef&"
import script from "./PagePlanogram.vue?vue&type=script&lang=js&"
export * from "./PagePlanogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports